<footer class="text-white pb-24 md:pb-6">
  <!-- Altura aumentada en móvil (py-12) -->
  <div
    class="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6"
  >
    <div class="flex items-center w-full justify-center px-4">
      <a
        (click)="showTC(true)"
        class="cursor-pointer open-terminos-condiciones-modal text-sm font-medium whitespace-nowrap hover:underline"
      >
        Términos y Condiciones
      </a>
      <span class="mx-2">|</span>
      <!-- Separador solo en desktop (oculto en móvil) -->
      <a
        (click)="showPP(true)"
        class="cursor-pointer open-politica-privacidad-modal text-sm font-medium whitespace-nowrap hover:underline"
      >
        Políticas de Privacidad
      </a>
    </div>
  </div>
</footer>

<!-- <p class="my-10 text-center text-white footerp">© 2025 UNIMEX</p> -->
<app-terminos-y-condiciones-modal
  [showTerminosyCondiciones]="showTerminosyCondiciones"
  [showPrivacyPolicy]="showPrivacyPolicy"
  (hideModal)="hideModal($event)"
></app-terminos-y-condiciones-modal>
